export enum AuctionTypeEnum {
    Annual = 1,
    Adhoc = 2,
}
